import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "SportsNextRacesWidget" */ './SportsNextRacesWidget'),
  modules: ['./SportsNextRacesWidget'],
  loading: () => <div />
});

export default LoadableWidget;
